import type { StorageManager } from '@/storage/save-data';

export function maybeShowTour(storage: StorageManager): void {
  if (storage.settings.tourDismissed) return;
  const backdrop = document.createElement('div');
  backdrop.className = 'editor-dialog-backdrop';
  backdrop.innerHTML = `
    <div class="editor-dialog">
      <h3>Welcome to the Editor</h3>
      <ol style="line-height:1.6;padding-left:20px;margin:0 0 14px">
        <li>🔺🧱⭐ Tap a palette button, then tap the preview to place.</li>
        <li>Drag to pan, pinch to zoom, drag the cyan line to set the playhead.</li>
        <li>▶ Test starts from the playhead.</li>
        <li>💾 Save commits to local storage; ⬆ Export sends the level or pack to a friend.</li>
      </ol>
      <div class="dialog-buttons">
        <button class="primary" id="tour-ok">Got it</button>
      </div>
    </div>
  `;
  document.body.appendChild(backdrop);
  backdrop.querySelector('#tour-ok')!.addEventListener('pointerdown', () => {
    backdrop.remove();
    storage.updateSettings({ tourDismissed: true });
  });
}
